
import Rater from 'vux/src/components/rater/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';

export default {

data(){
return {
serviceGradeNum:0,
serviceGrade:'',
evaluationDmDisabled:false,
msgForm:{
deal_date:'',
roast_content:'',
roast_date:'',
deal_details:'',
},
}
},
components: {
Rater, Radio, Group, Cell,XTextarea,XButton, PopupRadio
},
methods:{
getGrape(){
this.$nextTick(function(){
if(this.serviceGradeNum == 4){
this.serviceGrade = '非常满意';
this.msgForm.deal_result = '1';
}else if(this.serviceGradeNum == 3){
this.serviceGrade = '满意';
this.msgForm.deal_result = '2';
}else if(this.serviceGradeNum == 2){
this.serviceGrade = '一般满意';
this.msgForm.deal_result = '3';
}else if(this.serviceGradeNum == 1){
this.serviceGrade = '不满意';
this.msgForm.deal_result = '4';
}else if(this.serviceGradeNum == 0){
this.serviceGrade = '';
this.msgForm.deal_result = '';
}
})
},
getserviceGradeNum(){
if(this.msgForm.deal_result == ''){
this.serviceGradeNum = 0;
this.serviceGrade = '';
}else if(this.msgForm.deal_result == '1'){
this.serviceGradeNum = 4;
this.serviceGrade = '非常满意';
}else if(this.msgForm.deal_result == '2'){
this.serviceGradeNum = 3;
this.serviceGrade = '满意';
}else if(this.msgForm.deal_result == '3'){
this.serviceGradeNum = 2;
this.serviceGrade = '一般满意';
}else if(this.msgForm.deal_result == '4'){
this.serviceGradeNum = 1;
this.serviceGrade = '不满意';
}
},
msgSubmit(){
if(this.serviceGradeNum != 0){
fetch('post',urlConfig.SurveyserviceValuationSubmit,{deal_result:this.msgForm.deal_result,uuid:this.treatmentEp}).then(response =>{
promptMessage('提示','提交成功');
this.$router.push('/serviceSubmissionResult');

}).catch(function(error){
promptMessage('提示','提交失败,请重新提交！');
})
}else {
promptMessage('提示','请为处理结果选星评分哦！')
}

},//提交
getData(){
this.treatmentEp = this.$route.query.treatmentEp;
fetch('get',urlConfig.SurveyserviceValuationGet + '?treatmentEp='+this.treatmentEp).then(response=>{
this.msgForm = response;
this.getserviceGradeNum();
if(this.msgForm.deal_result){
this.evaluationDmDisabled = true;
}
this.getGrape();
}).catch(function(error){

})
}//获取数据
},
mounted(){
getken(this.getData);
}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/surveyServiceValuation.vue